(() => {
  const section = document.querySelector('.bas-home-choices');
  if (!section) return;

  const images = [...section.querySelectorAll('.bas-home-choices__image img')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;

  function update() {
    frame = 0;
    if (reducedMotion.matches) {
      images.forEach(image => image.style.removeProperty('--bas-parallax-y'));
      return;
    }

    images.forEach((image, index) => {
      const bounds = image.closest('.bas-home-choices__option').getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
      const progress = (window.innerHeight / 2 - (bounds.top + bounds.height / 2)) / ((window.innerHeight + bounds.height) / 2);
      const offset = Math.max(-12, Math.min(12, progress * (11 + index)));
      image.style.setProperty('--bas-parallax-y', `${offset.toFixed(1)}px`);
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener('change', schedule);
  schedule();
})();
